export const STORE_CENTERS = 'STORE_CENTERS';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const STORE_COMPANY_INFO = 'STORE_COMPANY_INFO';
export const STORE_COMPANY_GPS_DATA = 'STORE_COMPANY_GPS_DATA';

export const STORE_GRADES = 'STORE_GRADES';

export const STORE_VEHICLES = 'STORE_VEHICLES';

export const STORE_PASSENGERS = 'STORE_PASSENGERS';

export const STORE_QUICK_MESSAGES = 'STORE_QUICK_MESSAGES';

export const RESET = 'RESET';